ScoreTrekBattle.Tournament.Preset = ScoreTrekBattle.Tournament.Preset || {};

ScoreTrekBattle.Tournament.Preset.List = (function() {
    var _this, STATUS;

    function resetStatus() {
        STATUS = {
            isLoading: false,
            mode: 'custom',
            active: false,
            loaded: false,
            $view: null,
            $list: null,
            focusPresetId: null
        };
    }
    resetStatus();

    function onViewRender() {
        return new Promise(function(resolve, reject) {
            ScoreTrekBattle.View.updateMenu('/tournament/create');
            ScoreTrekBattle.Template.renderMulti([
                'tournament/nav/tabsPlan',
                'tournament/preset/list'
            ]).then(views => {
                var $tabs;

                $tabs = views['tournament/nav/tabsPlan'].$view;
                $tabs.find('[data-tab="tournament"]').addClass('isActive');
                $tabs.find('[data-tab="presets"]').addClass('isActive');

                STATUS.active = true;
                STATUS.$view = views['tournament/preset/list'].$view;
                STATUS.$list = STATUS.$view.find('[data-id="list"]');
                resolve($tabs.add(STATUS.$view));
            });
        });
    }

    function onViewLoadCustom(presetId) {
        STATUS.mode = 'custom';
        return new onViewLoad(presetId);
    }

    function onViewLoadOfficial(presetId) {
        STATUS.mode = 'official';
        return new onViewLoad(presetId);
    }

    function onViewLoad(presetId) {
        return new Promise(function(resolve) {
            STATUS.active = true;
            updateList(presetId);
            resolve();
        });
    }

    function onViewUpdate(presetId) {
        return new Promise(function(resolve) {
            setTimeout(() => {
                if (!STATUS.$list) {
                    return;
                }
                updateList(presetId);
            }, 0);
            resolve();
        });
    }

    function onViewUpdateCustom(presetId) {
        STATUS.mode = 'custom';
        return new onViewUpdate(presetId);
    }

    function onViewUpdateOfficial(presetId) {
        STATUS.mode = 'official';
        return new onViewUpdate(presetId);
    }

    function onViewUnload() {
        return new Promise(function(resolve) {
            resetStatus();
            resolve();
        });
    }

    function updateList(presetId) {
        if (STATUS.isLoading) {
            return;
        }

        STATUS.isLoading = true;
        ScoreTrekBattle.View.loading('Preset.List.updateList', true);

        STATUS.$view.find(`[data-tab^="presets:"]`).removeClass('isActive');
        STATUS.$view.find(`[data-tab="presets:${STATUS.mode}"]`).addClass('isActive');
        STATUS.$view.find('[data-id="button"]').css('display', (STATUS.mode === 'custom') ? '' : 'none');

        loadList().then(items => {
            renderList(items).then(() => {
                STATUS.loaded = true;
                setFocus(presetId || STATUS.focusPresetId);
            });
        }).catch(error => {
            chmDialog.error(error);
        }).finally(() => {
            STATUS.isLoading = false;
            ScoreTrekBattle.View.loading('Preset.List.updateList', false);        
        });
    }

    function loadList() {
        return new Promise(function(resolve, reject) {
            STATUS.$list.addClass('loading');
            Api.request('/battle/tournament/preset/list', {official: (STATUS.mode === 'official')}).then(result => {
                resolve(result.list);
            }).catch(reject).finally(() => {
                STATUS.$list.removeClass('loading');
            });
        });
    }

    function renderList(items) {
        return new Promise(function(resolve) {
            var promises;
            STATUS.$list.empty();
            promises = [];
            
            items.forEach(item => {
                promises.push(renderItem(item));
            });

            if (promises.length === 0) {
                promises.push(renderItem(null));
            }

            Promise.all(promises).then($items => {
                $items.forEach($item => {
                    // $item.hide();
                    STATUS.$list.append($item)
                    // $item.slideDown(400);
                });
                setTimeout(() => {
                    resolve();
                }, 400);
            });
        });
    }

    function renderItem(item) {
        return new Promise(function(resolve) {
            ScoreTrekBattle.Template.render(item ? 'tournament/preset/listItem' : 'tournament/preset/listItemEmpty', {preset: item}, true).then(itemView => {
                itemView.$view.find('[data-ref-mode]').not(`[data-ref-mode*="${STATUS.mode}"]`).remove();

                if (STATUS.mode === 'official') {
                    itemView.$view.removeAttr('data-show-for-club');
                }

                resolve(itemView.$view);
            });
        });
    }

    function setFocus(presetId) {
        STATUS.focusPresetId = null;

        if (presetId) {
            AnimationHandler.scrollIntoView(STATUS.$view.find(`[data-preset-id="${presetId}"]`)).then($element => {
                AnimationHandler.pulse($element);
            }).catch(ignore => {});
        }
    }

    _this = {
        focus: function(presetId) {
            if (STATUS.loaded) {
                setFocus(presetId);
            } else {
                STATUS.focusPresetId = presetId;
                setTimeout(() => {
                    if (!STATUS.$view) {
                        STATUS.focusPresetId = null;
                    }
                }, 100);
            }
        }
    };

    ScoreTrekBattle.View.register('/tournament/preset/list/custom', onViewRender, onViewLoadCustom, onViewUpdateCustom, onViewUnload, () => {
        return ScoreTrekBattle.Session.isBattleManager();
    });
    ScoreTrekBattle.View.register('/tournament/preset/list/official', onViewRender, onViewLoadOfficial, onViewUpdateOfficial, onViewUnload, () => {
        return ScoreTrekBattle.Session.isBattleManager();
    });
    ScoreTrekBattle.View.register('/tournament/preset/list', onViewRender, onViewLoad, onViewUpdate, onViewUnload, () => {
        return ScoreTrekBattle.Session.isBattleManager();
    });

    ScoreTrekBattle.Event.on('action.preset.click', function(event) {
        let link;

        if (event && $(event.target).closest('a').length > 0) {
            return;
        }

        link = $(this).closest('[data-preset-id]').find('a').get(0);

        if (link) {
            ScoreTrekBattle.View.goto(link.pathname + (link.search || ''));
        }
    });

    return _this;
})();